import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetFeedUseCase {
    execute(feed: string, filters: { [key: string]: string | number | boolean }): Promise<unknown>;
}

export class GetFeedUseCase implements IGetFeedUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(feed: string, filters: { [key: string]: string | number | boolean }): Promise<unknown> {
        return this.mpxRepository.getFeed(feed, filters);
    }
}
